'use client';

import { stegaClean } from '@sanity/client/stega';
import type { ITopBanner } from '@/sanity/lib/definitions';
import { getBannerDesign } from '@/lib/bannerCountdown';
import TopBannerClassic from '@/components/global/TopBannerClassic';
import TopBannerV1 from '@/components/global/TopBannerV1';
import TopBannerHalloween from '@/components/global/TopBannerHalloween';
import TopBannerBlackMonth from '@/components/global/TopBannerBlackMonth';

export interface TopBannerProps {
  data: ITopBanner;
  language?: string;
}

/**
 * Top banner entry point. The document's Design field picks the layout:
 * every banner saved before the field existed has no value and keeps the
 * classic look; "New UI 2026" renders the dark glass design with the optional
 * countdown (components/global/TopBannerV1.tsx), and its seasonal skins
 * render TopBannerHalloween / TopBannerBlackMonth.
 */
export default function TopBanner(props: TopBannerProps) {
  const design = getBannerDesign({ design: stegaClean(props.data?.design) });
  switch (design) {
    case 'v1':
      return <TopBannerV1 {...props} />;
    case 'halloween':
      return <TopBannerHalloween {...props} />;
    case 'blackMonth':
      return <TopBannerBlackMonth {...props} />;
    default:
      return <TopBannerClassic {...props} />;
  }
}
